import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import Button from "../components/UI/Button";
import Card from "../components/UI/Card";

const ContactScreen = () => {
  const { t } = useTranslation();
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
    subject: "general",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    // Simulate form submission
    setTimeout(() => {
      setIsSubmitting(false);
      setSubmitStatus("success");
      setFormData({
        name: "",
        email: "",
        phone: "",
        message: "",
        subject: "general",
      });
    }, 2000);
  };

  const handleContactAction = (type) => {
    switch (type) {
      case "phone":
        window.open("tel:+41793205349", "_self");
        break;
      case "email":
        window.open("mailto:info@villagebaidane.com", "_self");
        break;
      case "location":
        window.open(
          "https://maps.google.com/?q=Douar+Amzrou,+42051+Sidi+Abdehllaah+Ghiat,+Morocco",
          "_blank"
        );
        break;
      case "social":
        window.open("https://instagram.com/villagebaidane", "_blank");
        break;
      default:
        break;
    }
  };

  const contactInfo = [
    {
      icon: (
        <svg
          className="w-6 h-6"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
          />
        </svg>
      ),
      title: t("contact.info.phone.title"),
      details: ["+41 79 320 53 49", "+212 66 412 65 07"],
      action: t("contact.info.phone.action"),
      type: "phone",
    },
    {
      icon: (
        <svg
          className="w-6 h-6"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
          />
        </svg>
      ),
      title: t("contact.info.email.title"),
      details: ["info@villagebaidane.com"],
      action: t("contact.info.email.action"),
      type: "email",
    },
    {
      icon: (
        <svg
          className="w-6 h-6"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
          />
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
          />
        </svg>
      ),
      title: t("contact.info.location.title"),
      details: ["Douar Amzrou", "42051 Sidi Abdehllaah Ghiat", "Morocco"],
      action: t("contact.info.location.action"),
      type: "location",
    },
    {
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="currentColor"
          viewBox="0 0 24 24"
          class="h-6 w-6"
        >
          <path d="M7.75 2A5.75 5.75 0 0 0 2 7.75v8.5A5.75 5.75 0 0 0 7.75 22h8.5A5.75 5.75 0 0 0 22 16.25v-8.5A5.75 5.75 0 0 0 16.25 2h-8.5Zm0 1.5h8.5A4.25 4.25 0 0 1 20.5 7.75v8.5a4.25 4.25 0 0 1-4.25 4.25h-8.5a4.25 4.25 0 0 1-4.25-4.25v-8.5A4.25 4.25 0 0 1 7.75 3.5Zm8.75 2a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5ZM12 7a5 5 0 1 0 0 10 5 5 0 0 0 0-10Zm0 1.5a3.5 3.5 0 1 1 0 7 3.5 3.5 0 0 1 0-7Z"></path>
        </svg>
      ),
      title: t("contact.info.social.title"),
      details: ["@villagebaidane"],
      action: t("contact.info.social.action"),
      type: "social",
    },
  ];

  return (
    <div className="min-h-screen ">
      {/* Hero Section */}
      <section className="relative h-96 flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0 bg-black bg-opacity-55 "></div>
        <div
          className="absolute inset-0 bg-cover bg-center bg-no-repeat mix-blend-overlay"
          style={{
            backgroundImage: `url('/assets/images/villa Baidane-33.jpg')`,
          }}
        ></div>

        {/* Floating Elements */}
        <div className="absolute top-16 left-8 w-16 h-16 bg-white/10 rounded-full animate-float"></div>
        <div
          className="absolute bottom-20 right-12 w-12 h-12 bg-accent/30 rounded-full animate-float"
          style={{ animationDelay: "1s" }}
        ></div>

        <div className="relative z-10 text-center text-white px-4 max-w-4xl mx-auto">
          <h1 className="text-5xl md:text-7xl font-sofia font-bold mb-6 animate-fade-in-up">
            {t("contact.title")}
          </h1>
          <p
            className="text-xl md:text-2xl font-sofia font-light animate-fade-in-up opacity-90"
            style={{ animationDelay: "0.2s" }}
          >
            {t("contact.subtitle")}
          </p>
        </div>
      </section>

      {/* Contact Information Cards */}
      <section className="py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16 animate-fade-in-up">
            <h2 className="text-4xl font-sofia font-bold text-black mb-6">
              {t("contact.getInTouch")}
            </h2>
            <p className="text-lg font-sofia text-text-secondary max-w-3xl mx-auto">
              {t("contact.description")}
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
            {contactInfo.map((info, index) => (
              <Card
                key={index}
                hover
                className="text-center group animate-fade-in-up"
                style={{ animationDelay: `${index * 0.01}s` }}
              >
                <div className="w-16 h-16 bg-[#81736d]/10 rounded-full flex items-center justify-center mx-auto mb-4 text-[#81736d] group-hover:bg-[#81736d] group-hover:text-white transition-all duration-300">
                  {info.icon}
                </div>
                <h3 className="text-lg font-sofia font-semibold text-black mb-3">
                  {info.title}
                </h3>
                <div className="space-y-1 mb-4">
                  {info.details.map((detail, idx) => (
                    <p
                      key={idx}
                      className="text-text-secondary font-sofia text-sm"
                    >
                      {detail}
                    </p>
                  ))}
                </div>
                <Button
                  variant="ghost"
                  size="sm"
                  className="text-accent hover:bg-accent hover:text-white"
                  onClick={() => handleContactAction(info.type)}
                >
                  {info.action}
                </Button>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* Contact Form & Map */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16">
            {/* Contact Form */}
            <div className="animate-slide-in-left">
              <h3 className="text-3xl font-sofia font-bold text-black mb-8">
                {t("contact.form.title")}
              </h3>

              {submitStatus === "success" && (
                <div className="bg-green-50 border border-green-200 rounded-lg p-4 mb-6 animate-fade-in">
                  <div className="flex items-center">
                    <svg
                      className="w-5 h-5 text-green-500 mr-2"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M5 13l4 4L19 7"
                      />
                    </svg>
                    <p className="text-green-700 font-sofia">
                      {t("contact.form.success")}
                    </p>
                  </div>
                </div>
              )}

              <form onSubmit={handleSubmit} className="space-y-6">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div>
                    <label className="block text-sm font-sofia font-medium text-text-primary mb-2">
                      {t("contact.form.fullName")} *
                    </label>
                    <input
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleInputChange}
                      required
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-accent focus:border-accent transition-all duration-300 font-sofia"
                      placeholder={t("contact.form.placeholders.name")}
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-sofia font-medium text-text-primary mb-2">
                      {t("contact.form.email")} *
                    </label>
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleInputChange}
                      required
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-accent focus:border-accent transition-all duration-300 font-sofia"
                      placeholder={t("contact.form.placeholders.email")}
                    />
                  </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div>
                    <label className="block text-sm font-sofia font-medium text-text-primary mb-2">
                      Phone Number
                    </label>
                    <input
                      type="tel"
                      name="phone"
                      value={formData.phone}
                      onChange={handleInputChange}
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-accent focus:border-accent transition-all duration-300 font-sofia"
                      placeholder={t("contact.form.placeholders.phone")}
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-sofia font-medium text-text-primary mb-2">
                      {t("contact.form.subject")}
                    </label>
                    <select
                      name="subject"
                      value={formData.subject}
                      onChange={handleInputChange}
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-accent focus:border-accent transition-all duration-300 font-sofia"
                    >
                      <option value="general">
                        {t("contact.form.subjects.general")}
                      </option>
                      <option value="booking">
                        {t("contact.form.subjects.booking")}
                      </option>
                      <option value="services">
                        {t("contact.form.subjects.services")}
                      </option>
                      <option value="support">
                        {t("contact.form.subjects.support")}
                      </option>
                    </select>
                  </div>
                </div>

                <div>
                  <label className="block text-sm font-sofia font-medium text-text-primary mb-2">
                    {t("contact.form.message")} *
                  </label>
                  <textarea
                    name="message"
                    value={formData.message}
                    onChange={handleInputChange}
                    required
                    rows={6}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-accent focus:border-accent transition-all duration-300 font-sofia resize-none"
                    placeholder={t("contact.form.placeholders.message")}
                  ></textarea>
                </div>

                <Button
                  type="submit"
                  size="lg"
                  disabled={isSubmitting}
                  className="w-full md:w-auto"
                >
                  {isSubmitting ? (
                    <>
                      <svg
                        className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                        fill="none"
                        viewBox="0 0 24 24"
                      >
                        <circle
                          className="opacity-25"
                          cx="12"
                          cy="12"
                          r="10"
                          stroke="currentColor"
                          strokeWidth="4"
                        ></circle>
                        <path
                          className="opacity-75"
                          fill="currentColor"
                          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                        ></path>
                      </svg>
                      {t("contact.form.sending")}
                    </>
                  ) : (
                    t("contact.form.submit")
                  )}
                </Button>
              </form>
            </div>

            {/* Map & Location Info */}
            <div className="animate-slide-in-right">
              <h3 className="text-3xl font-sofia font-bold text-black mb-8">
                Find Us
              </h3>

              <div className="bg-gray-200 rounded-lg h-64 mb-6 flex items-center justify-center">
                <p className="text-text-secondary font-sofia">
                  Interactive Map Coming Soon
                </p>
              </div>

              <Card className="mb-6">
                <h4 className="text-lg font-sofia font-semibold text-black mb-4">
                  Location Details
                </h4>
                <div className="space-y-3 text-text-secondary font-sofia">
                  <p>📍 20km from Marrakech city center</p>
                  <p>✈️ 35 minutes from Marrakech Airport</p>
                  <p>🏔️ 15km from Atlas Mountains</p>
                  <p>🛡️ 12 hectares of secured property</p>
                  <p>🚗 Private parking available</p>
                </div>
              </Card>

              <Card>
                <h4 className="text-lg font-sofia font-semibold text-black mb-4">
                  Response Time
                </h4>
                <p className="text-text-secondary font-sofia mb-4">
                  We typically respond to inquiries within 2-4 hours during
                  business hours (9 AM - 8 PM Morocco time).
                </p>
                <p className="text-sm text-text-light font-sofia">
                  For urgent matters, please call us directly at +212 66 412 65
                  07
                </p>
              </Card>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ContactScreen;
